import Nullstack from 'nullstack';
export default function IconFingerprintOff({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-fingerprint-off",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M18.9 7a8 8 0 0 1 1.1 5v1a6 6 0 0 0 .8 3"
  }), "   ", Nullstack.element("path", {
    d: "M8 11c0 -.848 .264 -1.634 .713 -2.28m2.4 -1.621a4 4 0 0 1 4.887 3.901l-.001 1"
  }), "   ", Nullstack.element("path", {
    d: "M12 12v1a14 14 0 0 0 2.5 8"
  }), "   ", Nullstack.element("path", {
    d: "M8 15a18 18 0 0 0 1.8 6"
  }), "   ", Nullstack.element("path", {
    d: "M4.9 19a22 22 0 0 1 -.9 -7v-1a8 8 0 0 1 1.854 -5.143m2.176 -1.825a8 8 0 0 1 7.97 .018"
  }), "   ", Nullstack.element("path", {
    d: "M3 3l18 18"
  }), " ");
}